import React, { useCallback } from "react";
import { connect } from "react-redux";
import LoginForm from "../components/LoginForm";
import { bindActionCreators } from "redux";
import { actions } from "../modules/auth";
import { withRouter } from "react-router-dom";
import _ from "lodash/fp";
import sessionId from "../modules/sessionId";

const mapStateToProps = state => ({ ...(state.auth || {}) });
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(actions, dispatch)
});

const container = connect(
  mapStateToProps,
  mapDispatchToProps
);

const ShoppingCartLogin = ({
  authenticating,
  failAuth,
  login,
  history: { push },
  match: {
    params: { dealer_id }
  }
}) => {
  const onSubmit = useCallback(
    async values => {
      values.session_id = sessionId.get();
      values.dealer_slug = dealer_id;
      const { response } = await login(values);
      if (response) {
        sessionId.remove();
        push("/shopping-cart");
      }
    },
    [dealer_id, login, push]
  );
  return (
    <div className="login">
      <LoginForm
        authenticating={authenticating}
        failAuth={failAuth}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default _.pipe(
  container,
  withRouter
)(ShoppingCartLogin);
